import React, { FC, useMemo } from "react";
import { observer } from "mobx-react-lite";
import styles from "./index.module.scss";
import { galleryLangRecords } from "@/pages/Gallery/lang";
import { langStore } from "@noli/business";
import config from "@/config";
import { orderLangRecords } from "@/pages/Order/lang";

const Empty: FC<any> = (props) => {
  const lang = langStore.tgt;

  return (
    <div className={styles.EmptyWrapper}>
      <img src={`${config.buildCdnBaseUrl}assets/creator/emptyinbox.png`} alt="" />
      <p>
        {orderLangRecords[lang]["BoughtAnything"]}
        <br />
        {orderLangRecords[lang]["GetAcceleration"]}
      </p>
    </div>
  );
};
export default observer(Empty);
